import { gql } from "@apollo/client";

export const SAVE_EVALUACION_DIRECCION_PACIENTE = gql`
  mutation SaveDireccionPacienteFull($input: EvaluacionDireccionFullModelInput!) {
    saveDireccionPacienteFull(input: $input) {
      success
      error
      valorEsperado
    }
  }
`;